import type { FunctionComponent } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import MemedLogo from "../../../assets/svgs/common/solo-logo.svg";
import ArrowLeftIcon from "../../../assets/svgs/common/arrow-left.svg";
import { useAuthenticationStore } from "../../../store/authentication.store";

export const AuthLayoutCommonScreen: FunctionComponent = () => {
  const navigate = useNavigate();
  const { authenticationState } = useAuthenticationStore();
  return (
    <div className="relative bg-[url('/public/static/grid.png')] flex justify-center items-center md:bg-background bg-contain md:bg-none p-8 w-full h-screen text-primary container">
      <div className="top-0 absolute flex justify-center items-center md:hidden px-8 pt-16 w-full">
        <div className="relative flex justify-center items-center w-full">
          {authenticationState?.phone && (
            // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
            <div
              onClick={() => {
                navigate(0);
              }}
              className="left-0 absolute"
            >
              <ArrowLeftIcon />
            </div>
          )}

          <MemedLogo />
        </div>
      </div>
      <div className="items-center grid md:grid-cols-2 grid-flow-col w-full md:w-fit">
        <div className="md:flex justify-center items-center hidden rounded-3xl w-full max-w-lg h-fit">
          <img
            className="w-full h-fit object-contain"
            draggable={false}
            src="/static/illustration.png"
            alt=""
          />
        </div>
        <div className="flex justify-center items-center md:pl-24 h-full">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
